export const ADDITIONAL_INFORMATION_LIMIT = 255;
